import React from "react";
import { type Illustration, illustrationProps } from "../util";

export const InvoiceConnectionSuccess: Illustration = (props) => {
  return (
    <svg viewBox="0 0 267 203" {...illustrationProps(props, { width: 267 })}>
      <path
        stroke="#B8E682"
        strokeDasharray="0.1 12"
        strokeLinecap="round"
        strokeWidth="5"
        d="M225.706 140.964c0-50.923-41.282-92.205-92.206-92.205-50.923 0-92.205 41.282-92.205 92.205"
      />
      <rect
        width="100"
        height="100"
        x="167"
        y="102.394"
        fill="#000"
        rx="14.286"
      />
      <g clipPath="url(#a)">
        <path
          fill="#fff"
          d="m198.147 143.628-4.389 3.277c-2.072-1.783-4.743-2.133-6.217-2.133-1.474 0-3.046.427-3.287 1.497-.234 1.037.73 1.845 2.389 2.295 1.89.51 3.612.96 6.262 1.717 3.943 1.126 6.64 2.83 6.64 6.787 0 5.453-4.84 8.277-11.324 8.277s-10.901-3.379-12.221-4.954l4.64-3.47c3.26 2.841 5.526 3.242 7.42 3.242 2.173 0 4.206-.467 4.466-1.688.213-.987-.606-1.773-2.457-2.203-2.094-.483-3.863-.873-5.835-1.392-5.348-1.404-6.856-4.512-6.856-7.304 0-3.846 3.58-7.795 10.126-7.795 6.547 0 10.644 3.846 10.644 3.846m27.974-3.46h-19.566v24.453h19.924v-5.638h-13.053v-3.939h8.993v-5.396h-8.993v-3.894h12.694v-5.587l.001.001Zm-24.63 30.098h1.52v-35.75h-1.52v35.75Zm27.558 0h1.52v-35.75h-1.52v35.75Zm5.055-5.644h15.715c4.202 0 7.609-2.532 7.609-6.589 0-3.164-2.072-5.263-4.974-6.187 0 0-.12-.029-.281-.035a1.73 1.73 0 0 0 .281-.049c1.663-.659 3.504-2.411 3.504-5.394 0-3.785-3.348-6.199-7.481-6.199h-14.372v24.453h-.001Zm6.905-19.369h5.489c1.264 0 2.287.998 2.287 2.145 0 1.146-1.023 2.148-2.287 2.148h-5.489v-4.294.001Zm6.714 13.932-6.714.002v-4.46h6.714c1.188 0 2.15.963 2.15 2.23s-.962 2.229-2.15 2.229v-.001Z"
        />
      </g>
      <rect width="100" height="100" y="102.394" fill="#76C82E" rx="14.286" />
      <path
        fill="#fff"
        d="m13.589 151.869 8.25-9.553h4.607l-7.338 8.315 2.317 4.99c1.234 2.665 2.262 3.956 4.35 3.959.556 0 .967-.089.967-.089v3.281c-.47.118-1.117.175-1.645.175-3.287 0-5.37-2.227-6.898-5.48l-1.77-3.793-2.84 3.219v5.94H9.773v-20.517h3.816v9.553Zm18.813 10.964h-3.815v-20.517h3.815v20.517Zm5.842-20.517a66.742 66.742 0 0 0 5.343 16.873 66.675 66.675 0 0 0 5.374-16.873h3.786c-1.088 6.92-3.786 14.891-7.016 20.517h-4.314c-3.408-6.274-5.842-13.394-6.987-20.517h3.814Zm23.543-.352c4.372 0 7.661 2.961 7.658 7.062 0 3.025-1.826 5.305-4.544 6.166 2.323 1.258 4.376 4.375 4.69 7.638H65.63c-.382-3.339-2.758-6.271-6.134-7.062v-2.256c4.2 0 6.077-1.846 6.077-4.28 0-2.198-1.556-3.722-3.786-3.722-2.348 0-4.111 1.699-4.111 4.543v12.777H53.86v-13.07c0-4.924 3.613-7.796 7.927-7.796Zm20.37.349c3.464 6.215 5.959 13.63 7.161 20.517h-3.817a63.613 63.613 0 0 0-.933-4.674c-1.139.251-2.628.423-4.556.423-1.957 0-3.423-.169-4.556-.423a65.61 65.61 0 0 0-.933 4.674h-3.815c1.203-6.887 3.726-14.302 7.191-20.517h4.257Zm-2.141 3.377c-1.515 2.901-2.724 5.999-3.66 9.131.802.169 2.11.33 3.66.33 1.549 0 2.856-.161 3.658-.33-.936-3.132-2.144-6.23-3.658-9.131Z"
      />
      <path
        fill="#FEA628"
        d="M87.761 0c.966 0 1.749.783 1.749 1.748v5.104l4.009-4.009a1.748 1.748 0 1 1 2.472 2.473l-5.174 5.174h7.435a1.748 1.748 0 0 1 0 3.497h-6.27l4.01 4.009a1.748 1.748 0 0 1-2.473 2.472l-4.01-4.009v6.27a1.748 1.748 0 0 1-3.496 0v-7.435l-5.448 5.447a1.749 1.749 0 0 1-2.472-2.472l4.282-4.282h-6.27a1.748 1.748 0 0 1 0-3.497h7.436l-5.448-5.448a1.748 1.748 0 0 1 2.472-2.472l5.448 5.448v-6.27c0-.965.783-1.748 1.748-1.748Z"
      />
      <path
        fill="#BEC4FF"
        d="M109.827 87.575c-.174-1.118-.761-2.19-1.638-2.804-.844-.586-2.011-.668-2.979-.54-.629.082-1.175.256-1.68.687-.389.33-.662.788-.836 1.292-.463.201-.744.669-.794 1.264-.091 1.063.29 2.135.919 2.94.24.477.562.871 1.026 1.118a5.06 5.06 0 0 0 1.555.523c1.142.192 2.499.275 3.426-.632.364-.358.546-.816.604-1.31.066-.11.124-.22.174-.33.297-.715.339-1.439.223-2.208Zm-4.377.302s.016-.018 0 0Z"
      />
      <circle
        cx="133.5"
        cy="44.393"
        r="27.614"
        fill="#76C82E"
        transform="rotate(10.902 133.5 44.393)"
      />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M149.44 36.666a2.423 2.423 0 0 1-.62 3.369l-22.031 15.174a2.424 2.424 0 0 1-3.402-.67l-4.893-7.485a2.423 2.423 0 0 1 4.055-2.65l3.536 5.408 19.987-13.767a2.421 2.421 0 0 1 3.368.621Z"
        clipRule="evenodd"
      />
      <path
        fill="#FFB3B3"
        d="M185.41 36.707a82.953 82.953 0 0 1-2.25-3.549c-.478-.81-.266-1.787.505-2.33.727-.511 1.877-.255 2.33.505a82.271 82.271 0 0 0 2.222 3.507c1.222-.81 2.451-1.612 3.712-2.358.811-.477 1.787-.265 2.33.505.511.727.255 1.878-.505 2.33a85.364 85.364 0 0 0-3.67 2.33 85.94 85.94 0 0 0 2.513 3.611c.557.755.2 1.835-.505 2.33-.778.552-1.805.2-2.33-.505-.866-1.16-1.681-2.36-2.486-3.568a83.86 83.86 0 0 0-3.447 2.404c-.755.558-1.835.2-2.331-.505-.551-.778-.198-1.805.505-2.33a79.277 79.277 0 0 1 3.407-2.377Z"
      />
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M176 134.513h81.429v35.751H176z" />
        </clipPath>
      </defs>
    </svg>
  );
};
